// Maps old sorter columns to new sorter columns
// e.g. if the name of a column has changed, return the new name of the column
// the key should be the old column name / the value should be the new column name

export const DeprecatedSorterColumnMap = {
  counselor: 'atsCounselor',
  guidanceCounselorSy1617: 'guidanceCounselor',
  advisorSy1617: 'advisor',
};
